import { render, staticRenderFns } from "./FormBuscarAlumno.vue?vue&type=template&id=9027804c&scoped=true&"
import script from "./FormBuscarAlumno.vue?vue&type=script&lang=js&"
export * from "./FormBuscarAlumno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9027804c",
  null
  
)

export default component.exports